import React from 'react'
import Header from './components/Header/Header'
import LessonCard from './components/LessonCard/LessonCard'

const App = () => {
  return (
    <div>
    
    <Header />
    <LessonCard />
    
    </div>
  )
}

export default App